import { ReactNode } from 'react';

import { ICurbsideConfirmationModalProps } from './curbside-confirmation-modal/curbside-confirmation-modal';

export interface ITopServiceModeProps {}

// @TODO: extend component and hook props ( they are pretty much the same )
export interface ITopServiceModeViewProps {
  heading: string;
  details: ReactNode;
  icon: ReactNode;
  button?: ReactNode;
  onTopServiceClick?: () => void;
  variant?: TopServiceVariants;
  className?: string;
  isLoading?: boolean;
  reversed?: boolean;
}

export type ITopServiceModeWithFutureOrderingViewProps = ITopServiceModeViewProps & {
  futureOrderDate?: string | null;
};

export interface ITopServiceModeDetail {
  heading: string;
  details: ReactNode;
  icon: ReactNode;
  button?: ReactNode;
  onTopServiceClick?: () => void;
  variant?: TopServiceVariants;
  CurbsideConfirmationModal: React.FC<React.PropsWithChildren<ICurbsideConfirmationModalProps>>;
  curbsideConfirmationModalOpen: boolean;
  setCurbsideConfirmationModalOpen: React.Dispatch<any>;
  refetchUserOrder: () => void;
  futureOrderDate?: string | null;
}

export enum TopServiceVariants {
  DEFAULT = 'DEFAULT',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_STORE = 'NO_STORE',
  IN_RESTAURANT_LOYALTY = 'IN_RESTAURANT_LOYALTY',
}
